import type { ContentWithImageProps } from "modules/sections/ContentWithImage";
import { ContentWithImage } from "modules/sections/ContentWithImage";
import type { ReactStoryblokComponent } from "types/storyblok";

const ContentWithImageSection = ({
  blok: {
    srcMobile,
    srcDesktop,
    alt,
    reverseColumns,
    components,
    bgMobile,
    isIllustration,
    topDivider,
    ptMobile,
    ptTablet,
    ptDesktop,
    pbMobile,
    pbTablet,
    pbDesktop,
  },
}: ReactStoryblokComponent<ContentWithImageProps>) => (
  <ContentWithImage
    srcMobile={srcMobile}
    srcDesktop={srcDesktop}
    alt={alt}
    components={components}
    reverseColumns={reverseColumns}
    bgMobile={bgMobile}
    isIllustration={isIllustration}
    topDivider={topDivider}
    ptMobile={ptMobile}
    ptTablet={ptTablet}
    ptDesktop={ptDesktop}
    pbMobile={pbMobile}
    pbTablet={pbTablet}
    pbDesktop={pbDesktop}
  />
);

export { ContentWithImageSection };
